import { DITypes } from "@/core/@types/types";
import DownloadFileOnBrowser from "@/core/composables/download/adapters/DownloadFileOnBrowser";
import { IDownloadHandler } from "@/core/composables/download/handlers/DownloadHandler";
import DownloadPDFFile from "@/core/composables/download/adapters/DownloadPDFFile";
import DownloadStrategy from "@/core/composables/download/DownloadStrategy";
import DownloadZIP from "@/core/composables/download/adapters/DownloadZIP";
import PDFDownloadHandler from "@/core/composables/download/handlers/PDFDownloadHandler";
import ZIPDownloadHandler from "@/core/composables/download/handlers/ZIPDownloadHandler";
import {
  IDownload,
  IDownloadOnBrowser
} from "@/core/composables/download/types";
import { ContainerModule } from "inversify";
import PNGDownloadHandler from "@/core/composables/download/handlers/PNGDownloadHandler";
import DownloadPNGFile from "@/core/composables/download/adapters/DownloadPNGFile";
import DownloadPFXFile from "@/core/composables/download/adapters/DownloadPFXFile";
import PFXDownloadHandler from "@/core/composables/download/handlers/PFXDownloadHandler";

const downloadContainer = new ContainerModule((bind) => {
  bind<IDownloadOnBrowser>(DITypes.DOWNLOAD_ON_BROWSER)
    .to(DownloadFileOnBrowser)
    .inSingletonScope();
  bind<IDownloadHandler>(PDFDownloadHandler).toSelf().inSingletonScope();
  bind<IDownloadHandler>(ZIPDownloadHandler).toSelf().inSingletonScope();
  bind<IDownloadHandler>(PNGDownloadHandler).toSelf().inSingletonScope();
  bind<IDownloadHandler>(PFXDownloadHandler).toSelf().inSingletonScope();
  bind<IDownload>(DITypes.DOWNLOAD_PDF).to(DownloadPDFFile).inSingletonScope();
  bind<IDownload>(DITypes.DOWNLOAD_ZIP).to(DownloadZIP).inSingletonScope();
  bind<IDownload>(DITypes.DOWNLOAD_PNG).to(DownloadPNGFile).inSingletonScope();
  bind<IDownload>(DITypes.DOWNLOAD_PFX).to(DownloadPFXFile).inSingletonScope();
  bind(DownloadStrategy).toSelf().inSingletonScope();
});

export { downloadContainer };
